var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNonFormalSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Non-Formal_School",
    "data-name": "Non-Formal School",
    transform: "translate(-455 -169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4265",
    "data-name": "Rectangle 4265",
    width: 93,
    height: 93,
    rx: 10,
    transform: "translate(455 169)",
    fill: "#ffeff0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-no-education-739376",
    transform: "translate(455.2 169.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9862",
    "data-name": "Path 9862",
    d: "M67.03,40.515A21.115,21.115,0,1,0,45.915,61.63a24.888,24.888,0,0,0,5.15-.6v2.318a4.378,4.378,0,0,0-1.974,1.03,3.757,3.757,0,0,0-1.116,2.747,3.97,3.97,0,0,0,1.116,2.747l2.747,2.747,2.747-2.747a3.937,3.937,0,0,0,0-5.579,4.092,4.092,0,0,0-1.888-1.03V60.428A21.1,21.1,0,0,0,67.03,40.515ZM53.468,68.668l-1.545,1.545-1.545-1.545a2.186,2.186,0,1,1,3.09-3.09A2.175,2.175,0,0,1,53.468,68.668Zm-.6-10.128v-6.7c2.747-.944,4.463-2.575,4.463-4.463V41.03l4.721-1.888a2.029,2.029,0,0,0,0-3.777l-7.124-2.747L60.249,27.3A19.458,19.458,0,0,1,52.868,58.54ZM36.9,47.468V41.8l4.721,1.8-4.549,4.549A2.02,2.02,0,0,1,36.9,47.468ZM52.1,41.288l-3.09-2.661,4.635-4.635,7.811,3.09c.172.086.172.172.172.257s0,.172-.172.257Zm-1.8.687-2.4.944a4.078,4.078,0,0,1-3.176,0l3.09-3.09Zm-2.575-4.463-.944-.773-1.116,1.287.858.687L43,42.232,31.066,37.6c-.172-.086-.172-.172-.172-.257s0-.172.172-.257L44.628,31.76a5.541,5.541,0,0,1,1.631-.343,3.719,3.719,0,0,1,1.631.343l3.948,1.545ZM43.34,44.292l.6.257a6.854,6.854,0,0,0,2.232.429,6.447,6.447,0,0,0,2.232-.429l2.575-1.03v7.124a20.044,20.044,0,0,1-4.893.6c-3.519,0-6.352-.773-7.9-1.888Zm9.528-1.459,2.747-1.03v5.665c0,.944-1.03,1.888-2.747,2.575ZM45.915,21.117a19.046,19.046,0,0,1,13.047,5.064l-5.837,5.837-4.635-1.8a5.966,5.966,0,0,0-4.549,0L30.379,35.537a2.029,2.029,0,0,0,0,3.777L35.1,41.2v6.352a3.19,3.19,0,0,0,.687,1.888l-4.206,4.206A19.2,19.2,0,0,1,26.517,40.6,19.507,19.507,0,0,1,45.915,21.117Zm0,38.711a19.046,19.046,0,0,1-13.047-5.064l4.206-4.206c1.974,1.459,5.236,2.318,9.184,2.318a21.4,21.4,0,0,0,4.893-.515v6.781A20.834,20.834,0,0,1,45.915,59.828Z",
    fill: "#c3504f",
    stroke: "#c3504f",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonFormalSchool);
export default __webpack_public_path__ + "static/media/Non-Formal-School.77e3359794953d96fca756357a828cb1.svg";
export { ForwardRef as ReactComponent };